<template>
  <div class="typeahead_container siteSearch">
    <vue-typeahead-bootstrap
      v-model="query"
      :data="siteList"
      :serializer="item => item.dispName"
      @hit="addToList($event)"
      :placeholder="placeholderText"
      :disabled="fetchingList"
    />

    <!-- Selection list -->
    <div class="results">
      <div class="result" v-for="site in siteSelections" :key="site.id">
          <div class="name">
            <input type="hidden" name="site_list[]" :value="site.id" />
            {{site.dispName}}
          </div>
          <div class="action" v-on:click.prevent="removeFromList(site.id)" style="cursor: pointer;">
            <small class="text-danger">Remove</small>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueTypeaheadBootstrap from 'vue-typeahead-bootstrap';
export default {
  components: { VueTypeaheadBootstrap },
  props: {
    preSelections: Array,
    project: String,
    sitePrefix: String,
  },
  data: function() {
    return {
      fetchingList: false,
      query: '',
      siteList: [],
      siteSelections: {},
    };
  },
  computed: {
    placeholderText: function() {
      return (this.fetchingList) ? 'Loading site list. One moment...' : this.sitePrefix + ' number, name, or address';
    },
  },
  methods: {
    addToList: function(e) {
      console.log('Adding: ' + e);
      this.siteSelections[e.id] = e;
      this.query = '';
      this.checkCount();
    },
    checkCount: function() {
      var selectionCount = Object.keys(this.siteSelections).length;
      if(selectionCount > 0) this.$root.canContinue = true;
      else this.$root.canContinue = false;
    },
    fetchSites: function() {
      this.fetchingList = true;
      axios.get('/api/v1/sites?project=' + this.project + '&exclude_subscribed=1')
        .then(function(response) { this.siteList = response.data.data; }.bind(this))
        .then(function() {
            // Check for pre-selections
            if(this.preSelections && (this.preSelections.length > 0)) {
                console.log('Pre-selections found:');
                console.log(this.preSelections);

                this.preSelections.forEach(siteID => {
                    console.log('Site ID: ' + siteID);

                    var result = this.siteList.filter(obj => obj.id == siteID);
                    // console.log(result[0].dispName);
                    this.addToList( result[0] );
                });
            }
        }.bind(this))
        .catch(function(error) { console.error(error); })
        .finally(function() { this.fetchingList = false; }.bind(this));
    },
    removeFromList: function(siteID) {
      console.log('removing site #' + siteID);
      var itemDeleted = delete this.siteSelections[siteID];
      this.$forceUpdate();
      this.checkCount();
    },
  },
  mounted: function() {
    // console.log('Mounted site search for project ' + this.project);
    this.fetchSites();
  },
}
</script>
